<div class="page-size-selector-container">
  <mat-form-field class="input-wrapper">
    <mat-select
      [disabled]="disabled()"
      [ngModel]="pageSize()"
      panelClass="page-size-select-panel"
      panelWidth="auto"
      (selectionChange)="pageSizeChange.emit($event.value)">
      @for (availablePageSize of availablePageSizes; track availablePageSize) {
        <mat-option [value]="availablePageSize">
          {{ availablePageSize }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <span class="page-size-selector-text">{{ 'View.SizePickerInfo' | translate }}</span>
</div>
